// | ------------------------------------------------------------------------
// | Lazy YouTube Videos
// | ------------------------------------------------------------------------ 


var youtube = document.querySelectorAll( ".video-container" );
if(youtube.length>0){
for (var i = 0; i < youtube.length; i++) {
  var playbutton = youtube[i].innerHTML = "<div class='play-button'></div>";
var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/hqdefault.jpg";	
var image = new Image();
image.src = source;
image.addEventListener( "load", function() {
youtube[ i ].appendChild( image );
}( i ) );
youtube[i].addEventListener( "click", function() {
  this.innerHTML = "<div class='loading'><div class='loader'></div></div>";
var iframe = document.createElement( "iframe" );
      iframe.classList.add('embed-responsive-item');
iframe.setAttribute( "frameborder", "0" );
iframe.setAttribute( "allowfullscreen", "" );
iframe.setAttribute( "allow", "autoplay" );
iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?rel=0&showinfo=0&autoplay=1" );
this.appendChild( iframe );
} );};}